<template>
    <div 
        class="field-wrap"
        :class="{highlighted:highlighted}"
    >

        <!--<div class="field-col-wrap">
            <span>{{field.label[this.$store.state.user.languageCode].value}}</span>
            <div class="sepperator"></div>
            <label>{{field.label[this.$store.state.user.languageCode].value}}</label>
        </div>-->
        <div class="sepperator"></div>
        <div class="fieldSymbols">
            <img v-if='locked === "unlocked"' class='qrSymbol' :src='getImgUrl("qr_code.svg")'/>
            <img v-if='hasImage === true' class='qrSymbol' :src='getImgUrl("image.svg")'/>
        </div>
        <!-- TODO: use methods to get the filed properties for all fieldtypes (like textField)-->
         <transition name="highlight-unlocked" mode="out-in">
            <fieldLock 
                v-if='locked !== "unlocked" && locked !== false' 
                :lockType='locked'
                :formId='formId' 
                :fieldId='field.form_field_id'
                :parentId='field.parent_id'
                :label='getValueForCurLanguage(field.field_label).value'
                :description='getValueForCurLanguage(field.field_description).value'>
            </fieldLock>
            <div v-else-if="field.field_type.type === 'text'">
                <textField 
                    :formId='formId.toString()' 
                    :fieldId='field.form_field_id.toString()'
                    :parentId='field.parent_id'
                    :placeholder='getValueForCurLanguage(field.field_placeholder).value'
                    :value='getValue'
                    :label='getValueForCurLanguage(field.field_label).value'
                    :required='getRequired'
                    fix:false>
                </textField>
            </div>
            <div v-else-if="field.field_type.type === 'boolean'">
                <boolean 
                    :formId='formId'
                    :fieldId='field.form_field_id'
                    :parentId='field.parent_id'
                    :value='field.value'
                    :label='getValueForCurLanguage(field.field_label).value'
                    :description='getValueForCurLanguage(field.field_description).value'
                    :required='field.required'>
                </boolean>
            </div>
            <div v-else-if="field.field_type.type === 'radio'">
                <radio 
                    :formId='formId' 
                    :fieldId='field.form_field_id'
                    :parentId='field.parent_id'
                    :value='field.value'
                    :label='getValueForCurLanguage(field.field_label).value'
                    :description='getValueForCurLanguage(field.field_description).value'>
                </radio>
            </div>
            <div v-else-if="field.field_type.type === 'checkbox'">
                <check 
                    :formId='formId' 
                    :fieldId='field.form_field_id'
                    :parentId='field.parent_id'
                    :value='field.value'
                    :label='getValueForCurLanguage(field.field_label).value'
                    :description='getValueForCurLanguage(field.field_description).value'>
                </check>
            </div>
            <div v-else>
                unbekannter Feldtyp:
                {{field.field_type.type}}
            </div>
        </transition>
    </div>
</template>

<script>
import BooleanWithLableDesc from "@/components/FormFields/BooleanWithLableDesc.vue";
import RadioWithLableDesc from "@/components/FormFields/RadioWithLableDesc.vue";
import CheckWithLableDesc from "@/components/FormFields/CheckWithLableDesc.vue";
import TextFieldWithLable from "@/components/FormFields/TextAreaWithLable.vue";
import FieldLock from "@/components/FormFields/FieldLock.vue";
import { mapGetters } from 'vuex'

export default {
    props:{
        field: Object,
        fix: Boolean,
        formId: Number,
        highlighted: Boolean,
    },
    components: {
        'boolean':BooleanWithLableDesc,
        'check':CheckWithLableDesc,
        'radio':RadioWithLableDesc,
        'textField':TextFieldWithLable,
        'fieldLock':FieldLock,
    },
    methods:{
        getImgUrl(img) {
            return require('@/assets/'+img);
        },
    },
    computed:{
        hasImage: function(){
            var imagePresent = false;
            if(this.$store.state.local.checkResultsNew[this.formId] !== undefined){
                if(this.$store.state.local.checkResultsNew[this.formId][this.field.form_field_id] !== undefined){
                    var optionsArray = this.$store.state.local.checkResultsNew[this.formId][this.field.form_field_id].options
                    if(optionsArray !== null && optionsArray !== undefined && optionsArray.length > 0){
                        optionsArray.forEach(function(option){
                            if(Array.isArray(option.fileObjects) && option.fileObjects.length > 0){
                                imagePresent = true;
                            }
                        })
                    }
                }
            }
            return imagePresent;
        },
        //why all this methods?!?!?! just get the values from field
        getValue: function() {
            if(this.getValueForCurLanguage(this.field.field_value).value){
                return this.getValueForCurLanguage(this.field.field_value).value;
            }else{
                return this.field.value
            }
        },
        getLabel: function() {
            return this.getValueForCurLanguage(this.field.field_label).value;
        },
        getPlaceholder: function() {
            return this.getValueForCurLanguage(this.field.field_placeholder).value;
        },
        getDescription: function() {
            return this.getValueForCurLanguage(this.field.field_description).value;
        },
        getRequired: function() {
            if(this.field.required){
                return this.field.required
            }else{
                return false
            }
        },
        locked: function(){
            if( this.$store.state.local.checkResultsNew[this.formId][this.field.form_field_id] !== undefined 
                && this.$store.state.local.checkResultsNew[this.formId][this.field.form_field_id].lockedBy !== undefined 
                && this.$store.state.local.checkResultsNew[this.formId][this.field.form_field_id].lockedBy !== null){
                return this.$store.state.local.checkResultsNew[this.formId][this.field.form_field_id].lockedBy;
            }else{
                return false
            }
        },
        ...mapGetters([
            'getValueForCurLanguage',
        ])
    },
    watch: { 
        /*locked: function(newVal) { // watch it
            if(newVal == "unlocked"){
                
            }
        }*/
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    @import "@/assets/scss/styles.scss";
    .field-wrap{
        position: relative;
        color:$fontColorMedLight;
    }
    .highlighted{
        animation: bounce-in .4s;
    }
    .level1{
        margin: 5px 0;
    }
    .level2{
        margin:5px;
        .fieldSymbols{
            position: absolute;
            top:8px;
            left:8px;
            height: 15px;
            z-index: 10;
            .qrSymbol{
                width: 20px;
                height: 20px;
            }
        }
        .sepperator{
            border-bottom:1px solid rgba(0,0,0,.1);
            width: 100%;
            margin:auto auto 10px auto;
        }
    }
    .highlight-unlocked-enter-active{
        animation: bounce-in .4s;
    }

    .highlight-unlocked-leave{
        opacity:1;
        display:none;
    }
    .highlight-unlocked-leave-active{
        display:block;
        transition: opacity .3s linear;
    }
    .highlight-unlocked-leave-to{
        opacity:0;
    }

    @keyframes bounce-in {
        0% {
            transform: scale(0);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
</style>